<template>
  <div class="custom-actions">
    <div class="d-flex" v-if="rowData.hired_at === null && rowData.rejected_at === null">
      <button data-toggle="tooltip" data-placement="top" :title="__('forms.RecruitingApplicant.hire')"
        class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-edit"
        @click="hireApplicant(rowData)"
      >
      <i class="fa solid fa-thumbs-up"></i>
      </button>
      <button data-toggle="tooltip" data-placement="top" :title="__('forms.TrainingRequests.reject')"
        class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove ml-2"
        @click="rejectApplicant(rowData)"
      >
      <i class="fa solid fa-thumbs-down"></i>
      </button>
    </div>
    <div v-else-if="rowData.hired_at !== null && !isVueTable">
      <p class="text-voice-value ml-1 mt-4">
        <i style="color: #2A9D8F" class="fas fa-check-circle"></i>
        {{ __('views.enumSlugs.hiring') }}: {{ formatDate(rowData.hired_at) }}</p>
    </div>
    <div class="d-flex" v-else-if="rowData.rejected_at !== null && !isVueTable">
      <p class="text-voice-value ml-1 mt-2">
        <i style="color: #F04649" class="fas fa-times-circle"></i>
        {{ __('views.status_rejected') }}: {{ formatDate(rowData.rejected_at) }}</p>
      <button data-toggle="tooltip" data-placement="top" :title="__('forms.people_visibility.reset')" class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history ml-2" @click="reintegratesApplicant(rowData)">
        <i class="fa-solid fa-rotate-left"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
      required: true,
    },
    isVueTable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  mounted() {},
  methods: {
    reintegratesApplicant(rowData) {
      Vue.swal
        .fire({
          title: "Are you sure?",
          text: "You want reintegrate this person as applicant?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, reintegrate it!",
        })
        .then((result) => {
          if (result.value) {
            axios
              .put("/recruiting-applicants-reintegrate-applicant", {
                applicant_id: rowData.id,
              })
              .then(() => location.reload());
          }
        });
    },
    hireApplicant(rowData) {
      app.__vue__.$refs.recruiting_add_info_hiring_applicant.toggle(
        rowData.id,
        {}
      );
    },
    rejectApplicant(rowData) {
      //console.log("REJECT ",rowData);
      Vue.swal
        .fire({
          title: "Are you sure?",
          text: "You want reject this person?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, reject it!",
        })
        .then((result) => {
          if (result.value) {
            axios
              .post("/recruiting-applicants-reject-applicant", {
                applicant_id: rowData.id,
              })
              .then(() => location.reload());
          }
        });
    },
    formatDate (value, fmt = 'DD/MM/YYYY') {
      return (value == null) ? '' : this.$moment(value, 'YYYY-MM-DD').format(fmt)
    },
    formatDateTime (value, fmt = 'DD/MM/YYYY HH:mm') {      
      return (value == null) ? '' : this.$moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
    },
  },
};
</script>

<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}
.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
</style>
